import {Reducer} from "redux";
import {InitializationState} from "../types";
import * as Routines from "../routines";
import { SiteTypeEnum } from "../../../SiteTypeEnum";

const initializationState: InitializationState = {
  customersInitialized: false,
  userInitialized: false,
  deletedUsersInitialized: false,
  rolesInitialized: false,
  ldapInitialized: false,
  adminRoleInitialized: false,
  invoicesInitialized: false,
  siteType: SiteTypeEnum.PROFFWEB
};

const initialization: Reducer<InitializationState> = (state: InitializationState = initializationState, action: any) => {
  switch (action.type) {
    case Routines.initializeUsers.SUCCESS:
      return {
        ...state,
        userInitialized: true
      };
    case Routines.initializeDeletedUsers.SUCCESS:
      return{
        ...state,
        deletedUsersInitialized: true
      }
    case Routines.initializeCustomers.SUCCESS:
      return {
        ...state,
        customersInitialized: true
      };
    case Routines.initializeRoles.SUCCESS:
      return {
        ...state,
        rolesInitialized: true
      };
    case Routines.initializeLdapUsers.SUCCESS:
      return {
        ...state,
        ldapInitialized: true
      };
    case Routines.initializeAdminRole.SUCCESS:
      return {
        ...state,
        adminRoleInitialized: true
      };

    case Routines.initialize.SUCCESS:
      return{
        ...state,
        siteType: action.payload
      }
    case Routines.initializeInvoices.SUCCESS:
      return {
        ...state,
        invoicesInitialized: true
      };

    default:
      return state;
  }
};

export default initialization;
